// company.ts — FONTE UNICA dei dati aziendali e dei claim mostrati nel sito
// (hero, trust strip, territorio, recensioni, contatti, footer, JSON-LD).
//
// I valori NAP — telefono, indirizzo, email, P.IVA — sono CONFERMATI reali.
// Gli altri provengono dal mockup di design e sono DA VALIDARE: ognuno è marcato
// `TODO_DATO_REALE`. Correggi/valida QUI, in un posto solo. La forma è allineata al
// futuro modello CMS (settings Piranha). Vedi ADR 0004 e l'audit GEO della homepage.
import { GOOGLE_RATING } from './google-rating'

export interface CompanyInfo {
  legalName: string
  brand: string
  vatId: string
  foundedYear: number
  phone: string // formato visualizzato
  phoneHref: string // valore per href="tel:"
  email: string
  address: { street: string; locality: string; region: string; postalCode: string; country: string }
  clients: string
  comuniCount: number
  uptime: string
  googlePlaceId: string
  rating: { value: number | null; count: number | null; schemaEnabled: boolean }
  certifications: string[]
  social: { instagram?: string; facebook?: string; linkedin?: string; youtube?: string }
}

export const COMPANY: CompanyInfo = {
  legalName: 'Spadhausen S.r.l. Unipersonale',
  brand: 'Spadhausen',
  vatId: '02595700390', // reale

  foundedYear: 2008, // brand/attività dal 2008 (ditta individuale); conferita in S.r.l. nel 2018

  // ── NAP — confermati reali ──
  phone: '0544 2330899',
  phoneHref: 'tel:+3905442330899',
  email: 'info@spadhausen.com',
  address: {
    street: 'Via Faentina 175/A',
    locality: 'Ravenna',
    region: 'RA',
    postalCode: '48124', // sede unica, CAP ufficiale confermato
    country: 'IT',
  },

  // ── claim dal mockup: DA VALIDARE ──
  clients: '~7.000', // confermato (circa)
  comuniCount: 8, // comuni su rete proprietaria; via wholesale copertura nazionale
  uptime: '99,9%', // TODO_DATO_REALE: da confermare

  // Place ID Google della scheda Spadhausen (pubblico): usato dallo script di build per
  // pescare media+conteggio recensioni e per costruire il link "su Google".
  googlePlaceId: 'ChIJ1ZCbMA8HfkcR1S_bBQlCV08',

  // Recensioni Google: media + conteggio pescati a BUILD-TIME dalla Places API
  // (app/scripts/fetch-google-rating.mjs → google-rating.ts). value/count = null finché la
  // GOOGLE_PLACES_API_KEY non è configurata: in tal caso il badge NON viene mostrato
  // (niente dati inventati). NB: questo dato NON entra nell'AggregateRating JSON-LD —
  // policy Google: i rating nei dati strutturati devono essere first-party, raccolti sul
  // nostro sito. Qui resta solo un badge visivo con attribuzione "su Google".
  rating: { value: GOOGLE_RATING.value, count: GOOGLE_RATING.count, schemaEnabled: false },

  certifications: ['MANRS', 'IPv6'], // confermati; RIPE NCC / MIX-IT da confermare

  social: {
    facebook: 'https://www.facebook.com/Spadhausen',
    linkedin: 'https://www.linkedin.com/company/spadhausen',
    youtube: 'https://www.youtube.com/@spadhausen_internet_provider',
  },
}

// Anni di attività derivati da foundedYear (niente secondo dato da validare).
export function yearsActive(): number {
  return new Date().getFullYear() - COMPANY.foundedYear
}

// Formattazione numerica deterministica (indipendente dall'ICU del runtime di build,
// che a volte non applica il raggruppamento). it-IT: migliaia con ".", decimali con ",".
export const fmtNum = (n: number) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
export const fmtDecimal = (n: number) => n.toString().replace('.', ',')
